module.exports = __webpack_public_path__ + "assets/img/68f12a059af1d678b85415348f0c8bf4.svg";